export const P = 'P';
export const C = 'C';
export const E = 'E';
export const RBAC = 'RBAC';
export const PROJECTFILTERING = false;
